import React, { useState } from "react";
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";

export default function YerlemApps({setSidebarVisible}) {
  const [appList, setAppList] = useState([
    {
      name: "Umay",
      icon: "https://www.yerlem.com/img/modules/umay.jpg",
      link: "/yerlem",
    },
    {
      name: "Atlas",
      icon: "https://www.yerlem.com/img/modules/atlas.jpg",
      link: "/yerlem",
    },
    {
      name: "Kavi",
      icon: "https://www.yerlem.com/img/modules/kavi_guvenlik.jpg",
      link: "/yerlem",
    }
  ]);

  const LoaderComp = () => {
    return (
      <div className="flex w-full flex-column xl:flex-row xl:align-items-start p-4 gap-4">
        <Skeleton className="w-4 sm:w-8rem xl:w-6rem shadow-2 h-6rem block xl:block mx-auto border-round" />
        <div className="flex w-full flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
          <div className="flex w-full flex-column align-items-center sm:align-items-start gap-3">
            <Skeleton className="w-12rem border-round h-2rem" />
            <Skeleton className="w-full border-round h-1rem" />
            <div className="flex align-items-center gap-3">
              <Skeleton className="w-12rem border-round h-1rem" />
              <Skeleton className="w-12rem border-round h-1rem" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full h-full py-4 px-36 ">
      <div className="absolute top-2 left-2">
        <Button
          severity="info"
          label="Menu"
          icon="pi pi-bars"
          onClick={() => setSidebarVisible((visible) => !visible)}
        />
      </div>
      <div className="relative flex h-full items-center justify-start gap-6 flex-col">
        <div className="card p-4 bg-blue-50 rounded-md shadow-lg w-full ">
          {appList.length > 0 ? (
            <div className="flex flex-wrap justify-center ">
              {appList.map((item) => (
                <div
                  key={item.id}
                  className="flex flex-column hover:shadow-2xl cursor-pointer hover:rounded-xl hover:bg-white/50 justify-center items-center gap-2 p-4"
                >
                  <img
                    className="h-[14rem] bg-blue-50 block xl:block mx-auto shadow-2xl rounded-2xl m-4"
                    src={item.icon}
                    alt="Kullanıcı"
                  />
                  <span className="text-4xl">{item.name}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="w-full col-12">
              <LoaderComp />
              <LoaderComp />
              <LoaderComp />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
